import { handleDataOrder, handleDataOrderByPercentage } from '_utils/function'
import { HOST_ORDER_REFUNDED, BUYER_REFUNDED } from '_utils/constant'

export const isOrderRefunded = (order) =>
  Number(order?.status) === HOST_ORDER_REFUNDED ||
  Number(order?.buyerStatus) === BUYER_REFUNDED

export const getOrderAmount = (order) => {
  if (!order) return 0
  const fee =
    order.totalFee !== undefined
      ? Number(order.totalFee)
      : Number(order.totalPricePerOrder) || 0
  return isNaN(fee) ? 0 : fee
}

export const buildCombinedPaymentData = (
  order,
  eventAndOrderByIdState = [],
  listCombinedPaymentsState = []
) => {
  const { combinedPaymentRef = '' } = order || {}
  let listCombinedOrder = []
  let listCombinedDelivery = []

  if (!combinedPaymentRef) {
    return { listCombinedOrder, listCombinedDelivery }
  }

  const exitCombinedPayment = listCombinedPaymentsState?.findIndex(
    (item) => item.combinedPaymentRef === combinedPaymentRef
  )

  if (exitCombinedPayment !== -1) {
    const { orderCombinedPayment = [], deliveryCombinedPayment = [] } =
      listCombinedPaymentsState[exitCombinedPayment] || {}

    orderCombinedPayment.forEach((element) => {
      const { eid, ref: elementRef } = element
      const {
        orders,
        adminCost,
        discount,
        deliveryCost,
        productIdList = [],
        isPercentage = false,
        orderDiscountEnabled,
        orderDiscount,
      } = eventAndOrderByIdState?.find((item) => item.id === eid) || {}

      const { listOrder: otherListOrder = [] } = isPercentage
        ? handleDataOrderByPercentage(
            orders,
            adminCost,
            discount,
            deliveryCost,
            [...productIdList],
            orderDiscountEnabled,
            orderDiscount
          )
        : handleDataOrder(
            orders,
            adminCost,
            discount,
            deliveryCost,
            [...productIdList],
            orderDiscountEnabled,
            orderDiscount
          )

      const otherOrder = otherListOrder?.find((item) => item.ref === elementRef)
      if (otherOrder) {
        listCombinedOrder = [...listCombinedOrder, otherOrder]
      }
    })
    listCombinedDelivery = [...deliveryCombinedPayment]
  }

  return { listCombinedOrder, listCombinedDelivery }
}
